import { registerApplication } from 'single-spa';
import { queryClient } from '../config/query_client';
const cssApp = {
    bootstrap: async () => { },
    mount: async () => { },
    unmount: async () => { },
};
const commonProps = {
    appId: 'bcp',
    landscape: window.bifrostWeb.landscape,
    backend: window.bifrostWeb.backend,
    queryClient,
};
const removePortalPrefix = (moduleName) => {
    const prefix = 'portal-';
    return moduleName.startsWith(prefix) ? moduleName.substring(prefix.length) : moduleName;
};
export const registerModule = ({ name, isAlwaysActive = false, props = {} }) => {
    const jsModuleName = `@bifrost/${name}`;
    const cssModuleName = `@bifrost/${name}-styles`;
    registerApplication({
        name: jsModuleName,
        app: () => System.import(jsModuleName),
        activeWhen: isAlwaysActive ? () => true : `/${removePortalPrefix(name)}`,
        customProps: {
            ...commonProps,
            ...props,
        },
    });
    registerApplication({
        name: cssModuleName,
        app: async () => {
            const cssModule = await System.import(cssModuleName);
            document.adoptedStyleSheets = [...document.adoptedStyleSheets, cssModule.default];
            return cssApp;
        },
        activeWhen: () => true,
        customProps: {
            ...commonProps,
            ...props,
        },
    });
};
